export default __webpack_public_path__ + "static/media/message.io.d756ce12.svg";